/**
 * usePageTitle - React hook to set the browser tab title based on current route and document.
 *
 * Dynamically updates the page title for better navigation and accessibility.
 */
import { useEffect } from "react";
import { useRouteContext } from "../contexts/route-context";

const DEFAULT_TITLE = "Lurna";

export const usePageTitle = () => {
  const { currentPath, isOnDocumentPage, isOnPDFPage, documentTitle, setDocumentTitle } = useRouteContext();

  useEffect(() => {
    let title = DEFAULT_TITLE;

    if (isOnPDFPage && documentTitle) {
      title = `${documentTitle} • Lurna`;
    } else if (isOnDocumentPage && documentTitle) {
      title = `${documentTitle} • Lurna`;
    } else if (currentPath === "/") {
      title = "Dashboard • Lurna";
    } else if (currentPath === "/notes") {
      title = "Notes • Lurna";
    } else if (currentPath.startsWith("/course/") && documentTitle) {
      title = `${documentTitle} • Lurna`;
    } else if (currentPath.startsWith("/courses")) {
      title = "Courses • Lurna";
    } else if (currentPath === "/login") {
      title = "Login • Lurna";
    } else if (currentPath === "/signup") {
      title = "Sign Up • Lurna";
    } else if (currentPath === "/study-board") {
      title = "Study Board • Lurna";
    } else if (currentPath === "/study-sets") {
      title = "Study Sets • Lurna";
    } else if (currentPath === "/study-sets/new") {
      title = "New Study Set • Lurna";
    } else if (currentPath.startsWith("/study-sets/") && !currentPath.endsWith("/new") && !currentPath.endsWith("/edit")) {
      title = documentTitle ? `${documentTitle} • Lurna` : "Study Set Preview • Lurna";
    } else if (currentPath.endsWith("/edit")) {
      title = "Edit Study Set • Lurna";
    } else if (currentPath.endsWith("/pricing")) {
      title = "Pricing • Lurna";
    }

    document.title = title;
  }, [currentPath, isOnDocumentPage, isOnPDFPage, documentTitle]);

  // Clear document title when navigating away from document/course/study set pages
  useEffect(() => {
    if (!isOnDocumentPage && !currentPath.startsWith("/course/") && !currentPath.startsWith("/study-sets/")) {
      setDocumentTitle(undefined);
    }
  }, [currentPath, isOnDocumentPage, setDocumentTitle]);
}; 